// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 427) return "static/chunks/427-426a2228c23c4c40.js";
	if (chunkId === 970) return "static/chunks/970-19bc12ad4b145bc1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"69":"bc751b152ad03366","208":"e9097f21eaf69223","296":"58b166fc9ac6c802","750":"7183741a2d912be2","972":"ad081f87d1e612b4"}[chunkId] + ".js";
};